import { render, staticRenderFns } from "./cooperation-pay-index.vue?vue&type=template&id=e70c2704&scoped=true&"
import script from "./cooperation-pay-index.vue?vue&type=script&lang=js&"
export * from "./cooperation-pay-index.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-pay-index.vue?vue&type=style&index=0&id=e70c2704&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70c2704",
  null
  
)

export default component.exports